import StripeScriptLoader from './StripeScriptLoader';

export default StripeScriptLoader;



// WEBPACK FOOTER //
// ./app/javascript/common/components/StripeScriptLoader/index.js